import { render } from "./TrailerCard.vue?vue&type=template&id=e59a6a64&scoped=true"
import script from "./TrailerCard.vue?vue&type=script&lang=js"
export * from "./TrailerCard.vue?vue&type=script&lang=js"

import "./TrailerCard.vue?vue&type=style&index=0&id=e59a6a64&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59a6a64"]])

export default __exports__